import { render } from "./ModalHeaderNotification.vue?vue&type=template&id=1ccd6136&ts=true"
import script from "./ModalHeaderNotification.vue?vue&type=script&lang=ts"
export * from "./ModalHeaderNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__